import { render } from "./Tiles.vue?vue&type=template&id=8dbb17a8"
import script from "./Tiles.vue?vue&type=script&lang=ts"
export * from "./Tiles.vue?vue&type=script&lang=ts"
script.render = render

export default script